export const FEATURES = {
  SPELLCHECK: false, // Re-enable post-launch
};
